export const WaterKey = {
  WATER_SOURCE: 'source',
  WATER_WITHDRAWN_TF: 'totalwaterwithdrawal',
  WATER_CONSUMED_TF: 'totalwaterconsumed',
  WATER_COST_TF: 'watercost',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const WaterLabel = {
  WATER_SOURCE: 'Water Source',
  WATER_WITHDRAWN_TF: 'Total Water Withdrawn',
  WATER_CONSUMED_TF: 'Total Water Consumed',
  WATER_COST_TF: 'Water Cost',
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments'
};
